import PropTypes from 'prop-types';
import round from 'lodash/round';
import isNaN from 'lodash/isNaN';

import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import Tooltip from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';

const LeadMetric = props => {
  const { label, value, numerator, denominator, isPercentage } = props;
  const _value = (
    isPercentage
    ? round(numerator / denominator * 100, props.precision)
    : round(value, props.precision)
  );
  const TooltipComponent = props?.tooltip ? Tooltip : Box;
  return (
    <TooltipComponent title={props?.tooltip || ''}>
      <Card>
        <Stack 
          margin={1}
          padding={1} 
          gap={0.5} 
          alignItems='center' 
          justifyContent='center'
          style={{minWidth: '100px'}}
        >
          <Typography variant='h1' style={{color: props?.color}}>
            {
              isNaN(_value) 
              ? '-'
              : `${_value}${isPercentage ? '%' : ''}`
            }
          </Typography>
          <Typography variant='caption' style={{color: props?.color}}>{label}</Typography>
        </Stack>
      </Card>
    </TooltipComponent>
  );
};

LeadMetric.defaultProps = {
  precision: 1,
};

LeadMetric.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.string,
  isPercantage: PropTypes.bool,
  numerator: PropTypes.number,
  denominator: PropTypes.number,
};

export default LeadMetric;